import { classNames } from '@vkontakte/vkui';
import styles from './Button.module.css';

interface ButtonProps {
  className?: string;
  children?: React.ReactNode;
  onClick?: VoidFunction;
  href?: string;
  rel?: string;
  stretched?: boolean;
  mode?: 'primary' | 'secondary';
}

export function Button(props: ButtonProps) {
  const { className, children, onClick, href, rel, stretched = false, mode = 'primary' } = props;

  const commonClassName = classNames(styles.root, styles[mode], { [styles.stretched]: stretched }, className);

  if (href) {
    return (
      <a className={commonClassName} href={href} rel={rel} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <button className={commonClassName} onClick={onClick}>
      {children}
    </button>
  );
}
